function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-106"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 401.21,
    width: 39.22,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.76,
    y: 389.21,
    width: 57.02,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.48,
    y: 390.89,
    width: 68.63,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.01,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.33,
    y: 395.11,
    width: 126.81,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.89,
    y: 52.91,
    width: 163.84,
    height: 219.73,
    transform: "translate(343.58 -18.03) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.42,
    y: 162.11,
    width: 163.84,
    height: 1.33,
    transform: "translate(454.11 -128.56) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.82,
    y: 91.73,
    width: 197.98,
    height: 142.09,
    transform: "translate(361.61 325.54) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.14,
    y: 192.13,
    width: 35.22,
    height: 49.3,
    transform: "translate(489.5 433.56) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.48 224.08 210.69 224.08 213.22 174.78 178.01 174.78 175.48 224.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.44,
    y: 192.13,
    width: 35.22,
    height: 49.3,
    transform: "translate(342.09 433.56) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.77 224.08 136.99 224.08 139.52 174.78 104.31 174.78 101.77 224.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.55 162.52 179.49 165.94 187.73 99.08 139.78 95.66 131.55 162.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.79 136.36 282 136.36 284.54 87.06 249.32 87.06 246.79 136.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.59,
    y: 116.08,
    width: 35.22,
    height: 49.3,
    transform: "translate(432.02 290.92) rotate(-177.49)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.45,
    y: 101.08,
    width: 35.22,
    height: 49.3,
    transform: "translate(191.72 248.68) rotate(178.34)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.61,
    y: 94.75,
    width: 89.46,
    height: 131.56,
    transform: "translate(762.68 321.06) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.22,
    y: 94.75,
    width: 92.41,
    height: 131.56,
    transform: "translate(754.85 321.06) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.01,
    y: 122.07,
    width: 110.83,
    height: 76.93,
    transform: "translate(216.89 537.96) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,165.89v8.43h0a19.14,19.14,0,0,1-19.15-19.14v-8.44h0A19.15,19.15,0,0,1,387,165.89Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,137.43v8.44h0a19.15,19.15,0,0,1-19.15-19.15v-8.43h0A19.14,19.14,0,0,1,387,137.43Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,194.34v8.44h0a19.15,19.15,0,0,1-19.15-19.15v-8.44h0A19.15,19.15,0,0,1,387,194.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.12,
    y: 271.38,
    width: 28.07,
    height: 104.41,
    transform: "translate(548.31 647.16) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.86,
    y: 375.78,
    width: 188.29,
    height: 6.62,
    transform: "translate(370 758.18) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.82,
    y: 271.38,
    width: 178.3,
    height: 104.41,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.33,
    y: 284.23,
    width: 141.28,
    height: 34.24,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.33,
    y: 328.69,
    width: 141.28,
    height: 34.24,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.72,
    y: 314.91,
    width: 46.5,
    height: 4.7,
    rx: 2.07,
    transform: "translate(341.94 634.51) rotate(-180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.72,
    y: 359.37,
    width: 46.5,
    height: 4.7,
    rx: 2.07,
    transform: "translate(341.94 723.44) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.08,356.66c.07-24.19.67-57.18,4.73-69.12l5.56-2.26S392,287.52,389,324.63c-2.83,34.65-3.14,28.46-2.93,32,0,.49-.68.9-1.54.88h0C383.72,357.49,383.08,357.12,383.08,356.66Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.89,282.07c-8.05-6.69-25.61-11.7-44.09-12.06-7.26-.14,13.77,15.81,28,23.5,10.57,5.72,22.23,10.91,25.1,17C388.15,297.77,388,288.75,379.89,282.07Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.09,315.29c-5.61-4.66-17.85-8.15-30.73-8.4-5.06-.1,9.6,11,19.51,16.38,7.36,4,15.49,7.6,17.49,11.87C386.85,326.24,386.71,320,381.09,315.29Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.43,299c9.22-7.41,29-12.85,49.76-13.08,8.14-.08-10.28,16.27-29.77,23.81C402.9,315,388.9,324,385.51,330.86,386.71,316.56,387.21,306.45,396.43,299Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.4,275.65c6.05-6.19,19.65-12,34.17-14.16,5.7-.85-1.88,10.36-19.49,19.71-9.29,4.92-18.58,13-20.58,18.21C385.55,289.09,385.34,281.83,391.4,275.65Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.09,352.59l1.47,28.57a1.31,1.31,0,0,0,1.3,1.24h32.3a1.31,1.31,0,0,0,1.3-1.24l1.47-28.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.38 358.65 366.64 358.65 365.42 347.56 410.61 347.56 409.38 358.65",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-106"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-106",
    cx: 250,
    cy: 426.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-106"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.37,82l-.95-.32a17.33,17.33,0,0,0,.89-5.48h1A18.49,18.49,0,0,1,381.37,82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.58,71.18a17.74,17.74,0,0,0-10.92-11.54l.34-.94a18.7,18.7,0,0,1,11.53,12.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.81,76.21a15.12,15.12,0,1,0-20.22,14.22l10.38,4L367,91A15.12,15.12,0,0,0,378.81,76.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.34,85.88A11.08,11.08,0,1,1,355.16,96.3l-7.61,3L349,96.69A11.1,11.1,0,0,1,340.34,85.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.24,118.41c-4.19,3.7-13.09,6.44-18.21,6-2.61,16.78,11.42,30.14,11.42,30.14s17.93-7.35,21.58-23.94C409.1,129.17,401.8,123.38,399.24,118.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.25,126.9c-.79,11.6,6.81,21.32,9.77,24.63,4-2,14.56-8.31,18-19.4A35.05,35.05,0,0,1,398.57,122,35.09,35.09,0,0,1,383.25,126.9Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.55 72.53 226.23 57.99 244.35 66.34 212.55 72.53",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.79,
    y: 69.22,
    width: 37.78,
    height: 23.31,
    rx: 2.69,
    transform: "translate(-11.2 45.55) rotate(-11.01)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.55 72.53 230.68 80.87 244.35 66.34 212.55 72.53",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.88 61.44 217.43 74.77 230.68 80.87 241.36 69.52 235.91 53.57 212.88 61.44",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "212.88 61.44 217.43 74.77 230.68 80.87 241.36 69.52 235.91 53.57 212.88 61.44",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M210.81,119.29l-1.8-.1h0a10,10,0,0,0-1.29-1.61l.3-1.78-4.41-2.43-1.34,1.2h0a10.92,10.92,0,0,0-2.06-.23h0l-1-1.47-4.84,1.4-.1,1.81a9.56,9.56,0,0,0-1.62,1.29l-1.77-.31-2.43,4.42,1.19,1.33h0a10.85,10.85,0,0,0-.23,2.07h0l-1.46,1,1.4,4.84,1.79.1h0a10.8,10.8,0,0,0,1.29,1.62h0l-.3,1.77,4.42,2.43,1.33-1.2a10.94,10.94,0,0,0,2.07.23h0l1,1.47,4.84-1.4.09-1.8h0a11.39,11.39,0,0,0,1.62-1.3h0l1.77.3,2.43-4.41-1.21-1.34a10.07,10.07,0,0,0,.24-2h0l1.47-1Zm-9.36,10.54a5,5,0,1,1,3.42-6.2A5,5,0,0,1,201.45,129.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.17,116.72l-1.1-.06h0a5.82,5.82,0,0,0-.79-1l.19-1.09-2.7-1.49-.83.74h0a5.84,5.84,0,0,0-1.25-.14h0l-.64-.9-3,.86-.06,1.1a5.82,5.82,0,0,0-1,.79l-1.09-.19-1.49,2.7.73.82h0a7.48,7.48,0,0,0-.14,1.27h0l-.89.63.85,3,1.1.06h0a7.06,7.06,0,0,0,.8,1h0l-.19,1.08,2.7,1.49.82-.73a7.6,7.6,0,0,0,1.27.14h0l.63.9,3-.86.06-1.1h0a7,7,0,0,0,1-.79h0l1.08.18,1.49-2.7-.74-.82a6.58,6.58,0,0,0,.15-1.26h0l.89-.64ZM182,125a5,5,0,1,1,3.41-6.17A5,5,0,0,1,182,125Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-106"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.85,96.38c-4.64-.87-6.61,2-6.46,6.1s-3.06,10,1,10.79S298.86,97.31,293.85,96.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.76,306c13.9-39.7,24.43-91.34,24.43-91.34l-38.07-.62S257.26,279.29,254,307c-3.41,28.81-15.07,92.72-15.07,92.72l16.71,4.72S274.41,341.85,276.76,306Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,243.34s-1.11,30.49-2.47,48.13c3.58-11.45,6.83-23.22,9.61-34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1,416.93l-1.43,8.14a1.51,1.51,0,0,1-1.87,1.15c-2.47-.7-3.49-1.42-7.78-2.7-5-1.51-9.47-2.07-15.35-3.83-3.56-1.07-2-5.41,1-5.38,6.34.07,9.93-2.16,13.24-3.12,1.59-2.62,3.71-12.47,3.71-12.47l13.46,4.81S251.15,412.76,250.1,416.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,402.16l15.29,4.58a1.34,1.34,0,0,0,1.59-.74l2.26-4.93a1.27,1.27,0,0,0-.75-1.76l-16.57-5.25a1.36,1.36,0,0,0-1.72,1.06l-1,5.6A1.27,1.27,0,0,0,239,402.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,402.16l15.29,4.58a1.34,1.34,0,0,0,1.59-.74l2.26-4.93a1.27,1.27,0,0,0-.75-1.76l-16.57-5.25a1.36,1.36,0,0,0-1.72,1.06l-1,5.6A1.27,1.27,0,0,0,239,402.16Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.24,423.41l-1.56-7c-.48-4.26-.16-14.13-.16-14.13l-13.44.34s1,9,.95,12.17c-2.58,1.81-5.17,4.34-10.76,6-2.63.77-2.38,5.33,1.1,5.39,5.77.1,9.86-.57,14.78-.48,4.2.07,4.69.48,7.1.48A2.11,2.11,0,0,0,319.24,423.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.53,303.62c-1.16-41.07,3.45-64.7-2.6-88.76l-34.63-.52s9.27,65.16,13.82,92.3,11,95.67,11,95.67l17,.21S321.09,335.4,314.53,303.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5,405.36l16.08.25A1.37,1.37,0,0,0,320,404.4l.55-5.32a1.24,1.24,0,0,0-1.2-1.39l-17.51-.54a1.36,1.36,0,0,0-1.38,1.55l.87,5.6A1.24,1.24,0,0,0,302.5,405.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.5,405.36l16.08.25A1.37,1.37,0,0,0,320,404.4l.55-5.32a1.24,1.24,0,0,0-1.2-1.39l-17.51-.54a1.36,1.36,0,0,0-1.38,1.55l.87,5.6A1.24,1.24,0,0,0,302.5,405.36Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.12,139.05H275l-16.22-1.23q-6.84-.56-13.61-1.3a28.8,28.8,0,0,1-1.52-3.1,51.26,51.26,0,0,1-2.25-6.71c-.63-2.35-1.15-4.79-1.59-7.26s-.81-5-1.12-7.45l0-.2a3.46,3.46,0,0,0-6.83-.19A60.72,60.72,0,0,0,231,120a64.83,64.83,0,0,0,.19,8.46,51.44,51.44,0,0,0,1.52,8.66,34.14,34.14,0,0,0,3.68,8.75,5.69,5.69,0,0,0,3.66,2.6l.49.1c2.8.6,5.61,1.18,8.42,1.63s5.62.91,8.44,1.27,5.64.66,8.47.91,5.62.43,8.57.51a6.93,6.93,0,0,0,.7-13.83Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.32,140a200.19,200.19,0,0,0-26.54-3.22,42.31,42.31,0,0,0,.39,21.55s3.95,2,15.16.62C286.86,157.33,295.87,142.15,285.32,140Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.54,143.71a141.83,141.83,0,0,0-28.63-3.77c-10.44-.21-18.61,4.95-20.6,15.21a229,229,0,0,0-3.23,62.35c.08,3.71,47.12,3.39,51,0,1.69-13.25-.17-27.45,8.52-57.11C323.38,154.29,320.66,145.17,314.54,143.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.38,154c-.2.86-.73,1.47-1.19,1.36s-.66-.89-.46-1.75.73-1.47,1.19-1.36S286.58,153.18,286.38,154Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.16,129.56a62.83,62.83,0,0,0,.33-8.93,3.66,3.66,0,0,0-7.18-.84l-.06.21c-.69,2.46-1.45,5.13-2.3,7.63s-1.75,5-2.78,7.36a54.43,54.43,0,0,1-3.37,6.7,31.2,31.2,0,0,1-2.07,3q-7.2-.25-14.46-.71l-17.18-1.18H318a7.33,7.33,0,0,0-1.35,14.6c3.1.37,6,.59,9.05.78s6,.29,9,.33,6,0,9,0,6.05-.23,9.08-.43l.54,0a6,6,0,0,0,4.22-2.17,35.67,35.67,0,0,0,5.17-8.61,53.69,53.69,0,0,0,2.92-8.83A68.27,68.27,0,0,0,367.16,129.56Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.18,142.15a211.77,211.77,0,0,1,28.29.67,44.71,44.71,0,0,1-3.68,22.52s-4.45,1.51-16-1.66C302.92,160.13,295.79,142.84,307.18,142.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.72,125l7.84-5.77-9.1-7.38S358,118,360.59,122Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.27,109l-3.61-2a3.28,3.28,0,0,0-4.24.91l-3,3.92,9.1,7.38,3-5.44A3.51,3.51,0,0,0,375.27,109Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.09,167.05a3.47,3.47,0,0,0-4.46-2l-.12,0c-2.36.89-4.85,1.84-7.27,2.69s-4.87,1.7-7.3,2.44-4.85,1.39-7.23,2c-1.35.3-2.69.55-4,.74q-5-4.63-10-9.46L324.14,152l-.07-.07a6.93,6.93,0,0,0-9.95,9.63c2,2.17,4,4.14,6,6.13s4.11,3.91,6.25,5.79,4.28,3.73,6.49,5.53,4.48,3.56,6.77,5.28l.44.34a5.59,5.59,0,0,0,4.32,1,53.23,53.23,0,0,0,8.65-2.39,78.54,78.54,0,0,0,7.82-3.41q3.75-1.9,7.27-4.1A81,81,0,0,0,375,171,3.47,3.47,0,0,0,376.09,167.05Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.51,144.88a200.4,200.4,0,0,1,19.85,17.9,42.28,42.28,0,0,1-16.5,13.86s-4.12-1.66-10.42-11C303.39,155.13,308.92,138.36,317.51,144.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.62,171.21l8.73-3-6.48-9s-7.41,4-6,8.35Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.21,159.43l-2.79-2.74a3.09,3.09,0,0,0-4.08-.22l-3.67,2.85,6.65,8.86,3.91-4.1A3.32,3.32,0,0,0,387.21,159.43Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,148.65a9.47,9.47,0,0,1,2.19,6c9.29-1.59,17-6.2,18-12.36-1.57-1.48-2.61-1.22-2.61-1.22S299.19,146.58,288,148.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,148.65a11.27,11.27,0,0,0-6.48,3.59c-3.57-3.47,1.08-10.91,3.93-12.31a9.22,9.22,0,0,1,3.84-.27S285.34,141.77,288,148.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.2,119.44c-1.79,5.68-4.05,15.62-1.77,21.33a3.3,3.3,0,0,1-1.15,3.92,21.46,21.46,0,0,1-14.73,4.3c-5.94-.49-6.31-3.57-5.12-6.18a4.9,4.9,0,0,1,3.28-2.65c6-1.47,6.27-6.53,5.61-11.41Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.54,123.24l-8.21,5.51a22.51,22.51,0,0,1,.23,3.73c2.87-.07,7.11-2.72,7.74-5.64A9.92,9.92,0,0,0,301.54,123.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.43,111c-2.85,8.67-4.08,13.88-9.69,17.32-8.44,5.18-18.2-1.46-18-10.74.2-8.36,4.82-21.12,14.32-22.55A12.1,12.1,0,0,1,312.43,111Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,112.72a3.64,3.64,0,0,1-1.17-.2,4.28,4.28,0,0,1-2.58-3.12,9.29,9.29,0,0,1,3.27-9.23,3.94,3.94,0,0,1,6.55,2.32,8.72,8.72,0,0,1-.32,5.09C292.7,110.65,290.3,112.72,288,112.72Zm2.3-13.06a4.26,4.26,0,0,0-2.49.9,8.76,8.76,0,0,0-3.09,8.72,3.78,3.78,0,0,0,2.27,2.78c2.28.81,5.11-1.27,6.31-4.65h0a8.29,8.29,0,0,0,.31-4.79,3.83,3.83,0,0,0-2.28-2.79A3,3,0,0,0,290.34,99.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.23,116.33a3.35,3.35,0,0,1-1.17-.2c-2.53-.9-3.55-4.58-2.26-8.2a8.67,8.67,0,0,1,2.95-4.15,4,4,0,0,1,6.55,2.32,8.72,8.72,0,0,1-.32,5.09C302.89,114.27,300.48,116.33,298.23,116.33Zm2.3-13.06a4.38,4.38,0,0,0-2.5.9,8.26,8.26,0,0,0-2.78,3.92c-1.19,3.37-.31,6.78,2,7.59s5.11-1.28,6.31-4.65h0a8.24,8.24,0,0,0,.3-4.8,3.82,3.82,0,0,0-2.27-2.79A3.27,3.27,0,0,0,300.53,103.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,108.25a.27.27,0,0,1-.18-.08,1.18,1.18,0,0,0-1.2-.44.25.25,0,0,1-.3-.16.25.25,0,0,1,.15-.31,1.7,1.7,0,0,1,1.72.59.25.25,0,0,1,0,.34A.23.23,0,0,1,295,108.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.71,115.91a.24.24,0,0,1-.14,0c-5.08-3.67-7-4.1-7-4.1a.24.24,0,0,1,.09-.48c.08,0,2,.42,7.21,4.19a.25.25,0,0,1,.06.34A.26.26,0,0,1,310.71,115.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.64,118.35c-3.4-3.17-.12-6.71,2-8,2.33-1.44-1.18-3.11,1.68-6.61-11.6.28-9.12-5.09-15.24-4.46-3.34.34-6.68-2.61-6.26-7.32.79-8.9,13.52-10.91,15.54-7.57-4.79.85-3.78,3.79-1.68,4,5.46.45,4.41,3.23,7.31,5.84,4.12,3.7,9.19.5,8.55,8.23,8.1,2,3.61,11-1.53,13.4A35.41,35.41,0,0,1,306.64,118.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.75,102.31a5.71,5.71,0,0,0,5.74-6.4C324.53,101.61,320.84,103.4,315.75,102.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.32,120.37a8.86,8.86,0,0,1-5.76,2.66c-2.73.1-3.06-2.66-1.43-5,1.47-2.14,4.67-4.77,7-3.74S315.3,118.38,313.32,120.37Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.07,121.46c-1.32,1.31-3.23,1.55-4.25.52s-.77-2.92.56-4.24,3.23-1.56,4.25-.53S314.4,120.14,313.07,121.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.69,124.62a1.77,1.77,0,1,1,2.69-.77A2,2,0,0,1,292.69,124.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.81,124.05a23.14,23.14,0,0,1-5.12-.53.5.5,0,0,1,.23-1c4.91,1.17,12.85.39,15.72-2.36a.5.5,0,0,1,.71,0,.49.49,0,0,1,0,.7C308.14,123,303.29,124.05,298.81,124.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.6,110c-.24.7-.8,1.15-1.26,1s-.63-.83-.39-1.53.81-1.15,1.26-1S298.84,109.25,298.6,110Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,107c-.24.7-.8,1.15-1.26,1s-.63-.83-.39-1.53.81-1.15,1.26-1S290.28,106.3,290,107Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.15,109.33a63.29,63.29,0,0,0-6.27,3.73c.5,1.69,3.13,2.29,3.13,2.29Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,118.47a6.16,6.16,0,0,0,4.81-.44.22.22,0,0,0,.08-.3.22.22,0,0,0-.3-.07,5.84,5.84,0,0,1-5.28.07.22.22,0,0,0-.29.1.21.21,0,0,0,.09.29A7.78,7.78,0,0,0,291,118.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.8,108.75a.41.41,0,0,0,.22,0,.43.43,0,0,0,.28-.55,4.17,4.17,0,0,0-2.75-2.77.45.45,0,0,0-.54.32.43.43,0,0,0,.31.52h0a3.33,3.33,0,0,1,2.16,2.22A.43.43,0,0,0,302.8,108.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.38,103.12a.43.43,0,0,0,.41,0,3.43,3.43,0,0,1,3.13-.16.44.44,0,0,0,.59-.18.41.41,0,0,0-.16-.58,4.28,4.28,0,0,0-4,.16.43.43,0,0,0,0,.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.48,115l-6.93-6,9.14-6.23s5.62,6.26,2.86,9.9Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.74,99.23l3.55-1.64a3.11,3.11,0,0,1,3.92,1.18l2.48,3.93-9.14,6.23-2.41-5.34A3.3,3.3,0,0,1,225.74,99.23Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.09,156.5a6.75,6.75,0,0,0-9-3.27l-.31.14-1.52.71-1.65.75c-1.12.48-2.25,1-3.39,1.43-2.27,1-4.58,1.79-6.9,2.6s-4.67,1.52-7,2.15c-2.06.56-4.13,1-6.21,1.4-1.8-.46-3.7-1.07-5.6-1.76-2.39-.87-4.82-1.88-7.24-2.94s-4.86-2.18-7.29-3.32l-7.29-3.47-.07,0a3.38,3.38,0,0,0-3.71,5.56c2.14,1.93,4.32,3.65,6.57,5.36s4.57,3.31,7,4.85a85.41,85.41,0,0,0,7.48,4.34,54.26,54.26,0,0,0,8.46,3.55,5,5,0,0,0,1.82.19l.42,0a74.63,74.63,0,0,0,8.49-1.1c1.41-.24,2.77-.57,4.16-.87s2.73-.69,4.08-1.1c2.71-.77,5.36-1.69,8-2.72,1.3-.52,2.61-1,3.89-1.65.64-.3,1.29-.59,1.93-.91s1.24-.63,2-1.06A6.76,6.76,0,0,0,274.09,156.5Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.41,148a195.92,195.92,0,0,0-24,10.21,41.31,41.31,0,0,0,10.82,18s4.33-.22,13.12-6.86C283.19,162,283.41,144.74,273.41,148Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.85,157.39l-8.93-.86,3.71-10.14s8,1.78,7.89,6.24Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.76,149.29l1.89-3.31a3,3,0,0,1,3.78-1.29l4.2,1.7-3.71,10.14L195,153.66A3.23,3.23,0,0,1,193.76,149.29Z",
    style: {
      fill: "#ff8b7b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-106"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.9,241.5H91.1a2.58,2.58,0,0,1-2.58-2.58h0a2.58,2.58,0,0,1,2.58-2.59H408.9a2.58,2.58,0,0,1,2.58,2.59h0A2.58,2.58,0,0,1,408.9,241.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.88,
    y: 217.17,
    width: 15.17,
    height: 19.17,
    rx: 1.32,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.05,233.63a6.88,6.88,0,1,1,6.87-6.88A6.89,6.89,0,0,1,355.05,233.63Zm0-11.75a4.88,4.88,0,1,0,4.87,4.87A4.88,4.88,0,0,0,355.05,221.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.9,241.5H320.57a2.59,2.59,0,0,1-2.59-2.58h0a2.59,2.59,0,0,1,2.59-2.59H408.9a2.58,2.58,0,0,1,2.58,2.59h0A2.58,2.58,0,0,1,408.9,241.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.86,
    y: 241.5,
    width: 9.75,
    height: 78,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.47,241.5h18.6a0,0,0,0,1,0,0v1.86a2.14,2.14,0,0,1-2.14,2.14H381.61a2.14,2.14,0,0,1-2.14-2.14V241.5A0,0,0,0,1,379.47,241.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.45,
    y: 300.17,
    width: 14.57,
    height: 78,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355,
    y: 348.24,
    width: 19.47,
    height: 78,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.79,426.24H343.68a4.35,4.35,0,0,1,4.35-4.35h33.41a4.35,4.35,0,0,1,4.35,4.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.39,
    y: 241.5,
    width: 9.75,
    height: 78,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.98,
    y: 300.17,
    width: 14.57,
    height: 78,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.53,
    y: 348.24,
    width: 19.47,
    height: 78,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.32,426.24H114.21a4.35,4.35,0,0,1,4.35-4.35H152a4.35,4.35,0,0,1,4.35,4.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.27,233.22H136.49a1.56,1.56,0,0,0-1.55,1.56h0a1.56,1.56,0,0,0,1.55,1.55H256.27a1.56,1.56,0,0,0,1.56-1.55h0A1.56,1.56,0,0,0,256.27,233.22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.27,233.22H136.49a1.56,1.56,0,0,0-1.55,1.56h0a1.56,1.56,0,0,0,1.55,1.55H256.27a1.56,1.56,0,0,0,1.56-1.55h0A1.56,1.56,0,0,0,256.27,233.22Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.45,177.37h-85a3.77,3.77,0,0,0-3.8,4.44l7,48.53a5.33,5.33,0,0,0,5.08,4.44h85a3.77,3.77,0,0,0,3.8-4.44l-7-48.53A5.33,5.33,0,0,0,214.45,177.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.08,184.07a4.45,4.45,0,0,0-3.84-6.7H129.45a3.77,3.77,0,0,0-3.8,4.44l7,48.53a5.33,5.33,0,0,0,5.08,4.44h15.8a8.52,8.52,0,0,0,7.35-4.22Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminRafiki);
export default __webpack_public_path__ + "static/media/Admin-rafiki.2ddb77b888cec233c96b51cb54c0aa18.svg";
export { ForwardRef as ReactComponent };